/*
 * @@Author: MuYang
 */

// 外部config 后缀
export const HANDLE_SUFFIX = 'SchemaHandle'

// 内置处理后缀
export const PRETREATMENT_SUFFIX = 'Pretreatment'

// props后缀
export const PROPS_SUFFIX = 'Props'

// 区分 pur sur
export const PROJECT_CODE = window.fe?.apaas?.biz?.project

// 获取对象权限code
export const CUSTOM_OBJECT_AUTH_CODE = (function () {
  return ({
    'sur': {
      BATCH_DELETE: `apaas_sur_delete`,
      CREATE: `apaas_sur_create`,
      DELETE: `apaas_sur_delete`,
      DETAIL: `apaas_sur_detail`,
      EXPORT: `apaas_sur_export`,
      IMPORT: `apaas_sur_import`,
      LIST: `apaas_sur_list`,
      MODIFY_LEADER: `apaas_sur_changeowner`,
      UPDATE: `apaas_sur_update`
    },
    'mall': {
      BATCH_DELETE: `apaas_mall_delete`,
      CREATE: `apaas_mall_create`,
      DELETE: `apaas_mall_delete`,
      DETAIL: `apaas_mall_detail`,
      EXPORT: `apaas_mall_export`,
      IMPORT: `apaas_mall_import`,
      LIST: `apaas_mall_list`,
      MODIFY_LEADER: `apaas_mall_changeowner`,
      UPDATE: `apaas_mall_update`
    },
    'pur': {
      BATCH_DELETE: `apaas_delete`,
      CREATE: `apaas_create`,
      DELETE: `apaas_delete`,
      DETAIL: `apaas_detail`,
      EXPORT: `apaas_export`,
      IMPORT: `apaas_import`,
      LIST: `apaas_list`,
      MODIFY_LEADER: `apaas_changeowner`,
      UPDATE: `apaas_update`
    }
  })[PROJECT_CODE || 'pur']
})()

export const BUTTON_TYPES = {
  EXPORT: `apaas_export`,
  IMPORT: `apaas_import`,
  PRINT: `apaas_print`
}

// 固定系统内按钮分端后的apiName
export const BUTTON_API_NAME = ((project) => {
  return ({
    'pur': {
      'BUTTON_CREATE': 'company_button_create',
      'BUTTON_UPDATE': 'company_button_update',
      'BUTTON_DETAIL': 'company_button_detail',
      'BUTTON_DELETE': 'company_button_delete',
      'BUTTON_BATCH_DELETE': 'company_button_batch_delete',
      'BUTTON_IMPORT': 'company_button_import',
      'BUTTON_EXPORT': 'company_button_export',
      'BUTTON_BACK': 'company_button_back',
      'BUTTON_MODIFY_LEADER': 'company_button_modify_leader',
      'BUTTON_SUBMIT': 'company_button_submit',
      'BUTTON_PRINT': 'company_button_print'
    },
    'sur': {
      'BUTTON_CREATE': 'company_sur_button_create',
      'BUTTON_UPDATE': 'company_sur_button_update',
      'BUTTON_DETAIL': 'company_sur_button_detail',
      'BUTTON_DELETE': 'company_sur_button_delete',
      'BUTTON_BATCH_DELETE': 'company_sur_button_batch_delete',
      'BUTTON_IMPORT': 'company_sur_button_import',
      'BUTTON_EXPORT': 'company_sur_button_export',
      'BUTTON_BACK': 'company_sur_button_back',
      'BUTTON_MODIFY_LEADER': 'company_sur_button_modify_leader',
      'BUTTON_SUBMIT': 'company_sur_button_submit',
      'BUTTON_PRINT': 'company_sur_button_print'
    },
    'mall': {
      'BUTTON_CREATE': 'company_mall_button_create',
      'BUTTON_UPDATE': 'company_mall_button_update',
      'BUTTON_DETAIL': 'company_mall_button_detail',
      'BUTTON_DELETE': 'company_mall_button_delete',
      'BUTTON_BATCH_DELETE': 'company_mall_button_batch_delete',
      'BUTTON_IMPORT': 'company_mall_button_import',
      'BUTTON_EXPORT': 'company_mall_button_export',
      'BUTTON_BACK': 'company_mall_button_back',
      'BUTTON_MODIFY_LEADER': 'company_mall_button_modify_leader',
      'BUTTON_SUBMIT': 'company_mall_button_submit'
    }
  })[project]
})(PROJECT_CODE)

// 迁移对象 请求头
export const HEADER_PARAMS_KEYS = {
  tenantType: 'APAAS-TENANT-TYPE',
  objectApiName: 'APAAS-OBJECT-API-NAME',
  layoutApiName: 'APAAS-LAYOUT-API-NAME',
  operationApiName: 'APAAS-OPERATION-API-NAME',
  tabApiName: 'APAAS-TAB-API-NAME',
  menuApiName: 'MENU-API-NAME'
}

// 匹配paas-前缀
export const PAAS_REG = /paas-/

// 页面类型
export const LAYOUT_TYPE = {
  /**
   * 新建页
   */
  LAYOUT_TYPE_CREATE: 'layout_type_create',
  /**
   * 详情页
   */
  LAYOUT_TYPE_DETAIL: 'layout_type_detail',
  /**
   * 编辑页
   */
  LAYOUT_TYPE_UPDATE: 'layout_type_update',
  /**
   * 列表页
   */
  LAYOUT_TYPE_LIST: 'layout_type_list',
  /**
   * 聚合新建页
   */
  LAYOUT_TYPE_POLYMERIC_CREATE: 'layout_type_polymeric_create',
  /**
   * 聚合编辑页
   */
  LAYOUT_TYPE_POLYMERIC_DETAIL: 'layout_type_polymeric_detail',
  /**
   * 列表tab页
   */
  LAYOUT_TYPE_TAB_LIST: 'layout_type_tab_list',
  /**
   * 主从一方对象中的多方列表
   */
  LAYOUT_TYPE_LIST_MASTER_RELATION_MORE: 'layout_type_list_master_relation_more',
  /**
   * 查找一方对象中的多方列表
   */
  LAYOUT_TYPE_LIST_LOOKUP_RELATION_MORE: 'layout_type_list_lookup_relation_more',
  /**
   * 查找多方对象中的一方列表
   */
  LAYOUT_TYPE_LIST_LOOKUP_RELATION_ONE: 'layout_type_list_lookup_relation_one',
  /**
   * 聚合列表的布局类型
   */
  LAYOUT_TYPE_LIST_POLYMERIC: 'layout_type_list_polymeric',

  /**
   * 布局组关联目标类型--字段
   */
  TARGET_TYPE_FIELD: 'field',
  /**
   * 布局组关联目标类型--按钮
   */
  TARGET_TYPE_BUTTON: 'button',
  /**
   * 字段组类型-特殊组
   */
  TARGET_TYPE_SPECIAL: 'fieldGroup_type_special',
  /**
   * 字段组类型-摘要组
   */
  TARGET_TYPE_SUMMARY: 'fieldGroup_type_summary',
  /**
   * 字段组类型-筛选组
   */
  TARGET_TYPE_FILTER: 'fieldGroup_type_filter',
  /**
   * 字段组类型-普通组
   */
  TARGET_TYPE_NORMAL_GROUP: 'fieldGroup_type_normalGroup',
  /**
   * 字段组类型-卡片组
   */
  TARGET_TYPE_CARD: 'fieldGroup_type_card',
  /**
   * 布局组关联目标类型--查找关联
   */
  TARGET_TYPE_LOOKUP_RELATION: 'lookup_relation',
  /**
   * 布局组关联目标类型--主从关联
   */
  TARGET_TYPE_MASTER_RELATION: 'master_relation',
  /***
   * 布局组关联目标类型--字段组
   */
  TARGET_TYPE_FIELD_GROUP: 'fieldGroup',
  /**
   * 布局组关联视图字段
   */
  TARGET_TYPE_VIEW_FIELD: 'viewField',
  /**
   * 聚合列表
   */
  TARGET_TYPE_POLYMERIC: 'polymeric_list',
  /**
   * tab页签
   */
  TARGET_TYPE_TAB: 'tab',
  /**
   * 弹窗
   */
  LAYOUT_TYPE_POPUP: 'popup'
}

// 组件对应后端target
export const TARGET_TYPE = {
  [LAYOUT_TYPE.LAYOUT_TYPE_POPUP]: 'popup',
  [LAYOUT_TYPE.TARGET_TYPE_NORMAL_GROUP]: 'group',
  [LAYOUT_TYPE.TARGET_TYPE_SUMMARY]: 'group',
  [LAYOUT_TYPE.TARGET_TYPE_SPECIAL]: 'group',
  [LAYOUT_TYPE.LAYOUT_TYPE_LIST_MASTER_RELATION_MORE]: 'masterRelationGroup',
  [LAYOUT_TYPE.LAYOUT_TYPE_LIST_LOOKUP_RELATION_MORE]: 'masterRelationGroup',
  [LAYOUT_TYPE.TARGET_TYPE_MASTER_RELATION]: 'masterRelation',
  [LAYOUT_TYPE.TARGET_TYPE_POLYMERIC]: 'polymericList',
  [LAYOUT_TYPE.LAYOUT_TYPE_LIST_POLYMERIC]: 'masterRelationGroup',
  [LAYOUT_TYPE.LAYOUT_TYPE_POLYMERIC_CREATE]: 'page',
  [LAYOUT_TYPE.LAYOUT_TYPE_POLYMERIC_DETAIL]: 'page',
  [LAYOUT_TYPE.LAYOUT_TYPE_TAB_LIST]: 'list',
  [LAYOUT_TYPE.LAYOUT_TYPE_CREATE]: 'page',
  [LAYOUT_TYPE.LAYOUT_TYPE_UPDATE]: 'page',
  [LAYOUT_TYPE.LAYOUT_TYPE_DETAIL]: 'page',
  [LAYOUT_TYPE.TARGET_TYPE_LOOKUP_RELATION]: 'masterRelation',
  [LAYOUT_TYPE.TARGET_TYPE_FILTER]: 'filter',
  [LAYOUT_TYPE.TARGET_TYPE_CARD]: 'cards'
}

// 编辑页默认隐藏的字段类型
export const EDIT_HIDE_FIELD = ['paas-autoNumber']

// 数字金额字段小数点精度跟随系统/字段/币种
export const FOLLOW_SETTING_LIST = {
  SYSTEM: 1,
  FIELD: 2,
  CURRENCY: 3
}

/*
 * @@Author: MuYang
 */

// paas中权限点的常量
export const OPERATION_CODE = {
  BATCH_DELETE: 'BATCH_DELETE',
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  DETAIL: 'DETAIL',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  BACK: 'BACK',
  LIST: 'LIST',
  UPDATE: 'UPDATE',
  MODIFY_LEADER: 'MODIFY_LEADER'
}

// 布局中 SEQUENCE_CODE 唯一值的相关key
export const SEQUENCE_CODE_KEY_MAP = {
  TARGET_SEQ_CODE: 'targetSeqCode',
  // 新增的 SEQUENCE_CODE
  SEQUENCE_CODE: 'sequenceCode',
  // objectApiName -> objectSeqCode
  OBJECT_SEQUENCE: 'objectSeqCode',
  APINAME: 'apiName'
}

// 字段类型
export const FIELD_TYPE = {
  LOOKUP_RELATION: 'paas-lookupRelationship',
  QUOTE: 'paas-quote',
  PERSONNEL: 'paas-personnel',
  NUMBER: 'paas-number',
  FILE: 'paas-file',
  DATE: 'paas-date',
  PERCENTAGE: 'paas-percentage'
}

// 字段应用的字段类型
export const FIELD_VALUE_TYPE = {
  // 对象字段
  OBJECT: 1,
  // 能力参数
  PARAMS: 2,
  // 全局字段
  GLOBAL: 3,
}
